import React from "react";

// import bgImage from "../assets/img/catalog-bg.jpg";

export default function CatalogDownload({ pdfUrl, bgImage, title = "Katalogu İndir" }) {
    return (
        <section className="catalog-download-section" style={{
            backgroundImage: `linear-gradient(0deg, rgba(20,30,30,0.55), rgba(20,30,30,0.32)), url('${bgImage}')`
        }}>
            <div className="catalog-download-inner">
                <h2 className="catalog-download-title">{title}</h2>
                <a
                    href={pdfUrl}
                    className="catalog-download-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="fa fa-file-pdf me-2" style={{ fontSize: "2.2rem" }}></i>
                    Kataloğu İndir
                </a>
            </div>
        </section>
    );
}
